/* @flow */

export const IMAGE_UPDATED: string = 'survey@images:IMAGE_UPDATED';
export const IMAGE_DELETED: string = 'survey@images:IMAGE_DELETED';

export const updateImage = (image: CatalogResource) => ({
  type: IMAGE_UPDATED,
  image,
});

export const deleteImage = () => ({
  type: IMAGE_DELETED,
});



// WEBPACK FOOTER //
// ./src/modules/survey/actions/images.js